import cn from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage as Message } from 'react-intl';
import { ThemedButton } from 'src/templates/webview/ThemedButton';
import useRootElement from '../../hooks/useRootElement';
import styles from './Completed.module.css';

const Completed: React.FC<{ isWebview: boolean; onClose: () => void }> = ({ isWebview, onClose }) => {
  const { element, isIframe } = useRootElement();

  return ReactDOM.createPortal(
    <section className={cn(styles.root, isWebview && styles.webview, { [c(styles.iFrame)]: isIframe })}>
      <div className={cn(styles.inner, { [c(styles.iFrame)]: isIframe })}>
        <div className={styles.icon} />

        <div className={styles.text}>
          <span>
            <Message id={'System.IsCompletedSurvey1'} />
          </span>
          <span>
            <Message id={'System.IsCompletedSurvey2'} />
          </span>
        </div>

        {isWebview && (
          <div className={styles.button}>
            <ThemedButton appearance="secondary" onClick={onClose}>
              <Message id="System.SignOut" />
            </ThemedButton>
          </div>
        )}
      </div>
    </section>,
    element,
  );
};

export default Completed;
